import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';
import { getLeadDataTableSettingsFromProps } from 'common/apartmentLocatorHelpers';

import { actionDataTableLoadItems } from 'client/helpers/dataTables';

export default async function addUserMoveInDatePastMonthRange(
  { state, apiClient },
  { leadStatus, searchText, sortCriteria },
) {
  const statePath = ['apartmentLocator', 'leadsByStatus', leadStatus];
  const leadStatusState = state.select(statePath);

  const userMoveInDatePastMonthsRange = leadStatusState.get(['userMoveInDatePastMonthsRange']);
  const initialMonth = (userMoveInDatePastMonthsRange.length + 1) * 4;
  const initialDate = momentWithAustinTimezone()
    .startOf('month')
    .subtract(initialMonth, 'months')
    .toISOString();
  const userMoveInDateRange = [
    initialDate,
    momentWithAustinTimezone(initialDate).add(4, 'months').toISOString(),
  ];

  leadStatusState.unshift(['userMoveInDatePastMonthsRange'], userMoveInDateRange);
  state.commit();

  actionDataTableLoadItems(
    { state, apiClient },
    {
      ...getLeadDataTableSettingsFromProps({
        currentUser: state.get('currentUser'),
        leadStatus,
        userMoveInDateRange,
        searchText,
        sortCriteria,
      }),
      onSuccess: ({ items }) => {
        leadStatusState.set(['shouldLoadMorePastMonths'], items.length > 0);
        state.commit();
      },
    },
  );
}
